import { createSlice } from '@reduxjs/toolkit';

/**
 * A counter bumped whenever a partner's test restaurant is marked or unmarked
 * in this session, from whichever screen. The restaurant picker keys its
 * cached options on it so the TEST tags follow at once — including when the
 * restaurant that changed is not the selected one.
 */
export default createSlice({
  name: 'testRestaurants',
  initialState: {
    version: 0,
  },
  reducers: {
    bump: (state) => {
      state.version += 1;
    },
  },
});
